const BASE_URL = "https://parallelum.com.br/fipe/api/v1";

export const fetchData = async (brand, model, year) => {
  const url = `${BASE_URL}/caminhoes/marcas/${brand}/modelos/${model}/anos/${year}`;
  const response = await fetch(url);
  return  response.json();
};